.compactIdContainer {
  overflow: hidden;

  .compactId {
    position: relative;
    text-underline-offset: var(--ixf-space-1);
    justify-content: center;

    &.align {
      &-left {
        justify-content: flex-start;
      }

      &-right {
        justify-content: flex-end;
      }

      &-center {
        justify-content: center;
      }
    }

    &.fixedWidth {
      &.fillParent {
        text-align: center;
      }
    }

    &:not(.fixedWidth) {
      .shortContainer,
      .idText {
        width: 100%;
      }

      .idText {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    &.fillParent {
      width: 100%;
      display: flex;
    }

    a,
    button {
      transition: opacity 200ms ease;

      &:hover,
      &:focus,
      &:active {
        outline: none;
        opacity: 0.5;
      }
    }
  }
}
